/** PRODUCT FORMAT CENTRE — SUNTRONIX workspace: Smart Format · HSN Format · Image Format · One-Click Product Cleanup.
 *  Purpose: transform inconsistent OEM / distributor product information into clean, standardised CRM-ready records. */
import { useSearchParams } from "react-router-dom";
import { Sparkles, Hash, ImageIcon, Wand2, Layers } from "lucide-react";
import SmartFormatTool from "@/components/productcleanup/SmartFormatTool";
import HsnFormatTool from "@/pages/tools/HsnFormatTool";
import ImageFormatTool from "@/pages/tools/ImageFormatTool";
import OneClickCleanup from "@/components/productcleanup/OneClickCleanup";

const TABS = [
  { key: "cleanup", label: "One-Click Product Cleanup", icon: Wand2, blurb: "Raw OEM data → CRM-ready record with readiness score" },
  { key: "smart", label: "Smart Format Tool", icon: Sparkles, blurb: "Bold the facts that matter, per brand emphasis profile" },
  { key: "hsn", label: "HSN Format Tool", icon: Hash, blurb: "Verify HSN / GST against the SUNTRONIX HSN Master" },
  { key: "image", label: "Image Format Tool", icon: ImageIcon, blurb: "Standardised, auto-named product images" },
];

export default function ProductFormatCentre() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === params.get("tab")) ? params.get("tab") : "cleanup";
  const select = (k) => { params.set("tab", k); setParams(params, { replace: true }); };
  return (
    <div className="mx-auto max-w-[1400px] p-4" data-testid="pfc-root">
      <div className="rounded-2xl bg-slate-900 p-6 text-white">
        <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-300"><Layers className="h-3.5 w-3.5" /> SUNTRONIX workspace</div>
        <h1 className="mt-1 text-2xl font-bold text-white" data-testid="pfc-title">PRODUCT FORMAT CENTRE</h1>
        <p className="mt-1 max-w-3xl text-[13px] text-slate-300">Transform inconsistent OEM / distributor product information into clean, standardised SUNTRONIX CRM-ready product records — identity, specification, HSN / GST, image and filename in one pass, with complete version history and audit log.</p>
        <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-testid="pfc-tabs">
          {TABS.map((t) => <button key={t.key} onClick={() => select(t.key)} data-testid={`pfc-tab-${t.key}`}
            className={`rounded-xl border p-3 text-left transition-colors ${tab === t.key ? "border-sky-400 bg-sky-500/15" : "border-slate-700 hover:border-slate-500"}`}>
            <div className="flex items-center gap-2 text-[13px] font-semibold"><t.icon className="h-4 w-4 text-sky-300" />{t.label}</div>
            <div className="mt-0.5 text-[11px] text-slate-400">{t.blurb}</div>
          </button>)}
        </div>
      </div>
      <div className="mt-4" data-testid={`pfc-panel-${tab}`}>
        {tab === "cleanup" && <OneClickCleanup />}
        {tab === "smart" && <SmartFormatTool />}
        {tab === "hsn" && <HsnFormatTool />}
        {tab === "image" && <ImageFormatTool />}
      </div>
    </div>
  );
}
